import Hyperlink from '../HyperLink'
import PropTypes from 'prop-types'
import TrustpilotDesign from '../TrustpilotDesign'
import { useTrustMarkers } from 'src/common/trust-markers'
import {
  trustMarkerEntryRatingNumber,
  trustMarkerEntryTotalReview,
} from 'src/common/trustMarkerEntryFields'

const TrustpilotItem = ({
  className,
  trustpilotClassName,
  trustScoreClassName,
  trustpilotRatingClassName,
  starClassName,
  starsGroupClassName,
  starsGroupImgClassName,
  isHome = false,
  shortText = false,
  detailsText = false,
  disableRedirect = false,
  truspilotReviews,
  truspilotScore,
  imagePriority = true,
}) => {
  const { getTrustMarkerById } = useTrustMarkers()
  const trustPilot = getTrustMarkerById('truspilot')
  const tpRating = trustMarkerEntryRatingNumber(trustPilot)
  const tpReviews = trustMarkerEntryTotalReview(trustPilot)

  if (disableRedirect) {
    return (
      <TrustpilotDesign
        className={className}
        trustpilotClassName={trustpilotClassName}
        trustScoreClassName={trustScoreClassName}
        trustpilotRatingClassName={trustpilotRatingClassName}
        starClassName={starClassName}
        starsGroupClassName={starsGroupClassName}
        starsGroupImgClassName={starsGroupImgClassName}
        isHome={isHome}
        detailsText={detailsText}
        shortText={shortText}
        truspilotReviews={tpReviews ?? truspilotReviews}
        truspilotScore={
          Number.isFinite(tpRating) ? tpRating : Number(truspilotScore)
        }
        imagePriority={imagePriority}
      />
    )
  }

  return (
    <Hyperlink
      href="https://www.trustpilot.com/review/freedomdebtrelief.com"
      target="_blank"
      rel={`noreferrer`}
      clickTracking={true}
      clickTrackText="Trustpilot"
    >
      <TrustpilotDesign
        className={className}
        trustpilotClassName={trustpilotClassName}
        trustScoreClassName={trustScoreClassName}
        trustpilotRatingClassName={trustpilotRatingClassName}
        starClassName={starClassName}
        starsGroupClassName={starsGroupClassName}
        starsGroupImgClassName={starsGroupImgClassName}
        isHome={isHome}
        detailsText={detailsText}
        shortText={shortText}
        truspilotReviews={tpReviews ?? truspilotReviews}
        truspilotScore={
          Number.isFinite(tpRating) ? tpRating : Number(truspilotScore)
        }
        imagePriority={imagePriority}
      />
      {/* Legacy rendering block intentionally removed. */}
    </Hyperlink>
  )
}

TrustpilotItem.propTypes = {
  className: PropTypes.string,
  trustpilotClassName: PropTypes.string,
  trustScoreClassName: PropTypes.string,
  trustpilotRatingClassName: PropTypes.string,
  starClassName: PropTypes.string,
  starsGroupClassName: PropTypes.string,
  starsGroupImgClassName: PropTypes.string,
  isHome: PropTypes.bool,
  shortText: PropTypes.bool,
  imagePriority: PropTypes.bool,
}

export default TrustpilotItem
